import cn from '../../../common/className.js'
import Icon from '../../../common/icons/Icon.js'

const SHIPPABILITY_ICONS = {
  unshippable: 'ban',
  partially_shippable: 'exclamation-triangle',
  shippable: 'check-circle',
  shipped: 'cube',
  dropshippable: 'truck',
}

function getHint(shippability) {
  if (shippability === 'partially_shippable') {
    return 'Some lines are out of stock'
  }
  if (shippability === 'unshippable') {
    return 'All lines are out of stock'
  }
  return null
}

export default function ShippabilityIcon({shippability, className}) {
  if (shippability === 'shippable' || shippability === 'shipped') {
    return null
  }

  return (
    <div
      className={cn`wrap--order-shippability ${className} ${{
        'partially-shippable': shippability === 'partially_shippable',
        unshippable: shippability === 'unshippable',
      }}`}
    >
      <div className="tooltip--top" data-hint={getHint(shippability)}>
        <Icon
          name={SHIPPABILITY_ICONS[shippability] || 'ban'}
          className="fs-00"
        />
      </div>
    </div>
  )
}
